import { useMsal } from "@azure/msal-react";
import { useTranslation } from "react-i18next";
import { loginRequest } from "../../config/authConfig";
import classes from "./ADLogin.module.css";

export const SignInButton = (props: any) => {
  const { t } = useTranslation();
  const { instance } = useMsal();

  const handleADLogin = () => {
    console.log("==================ADLOGIN");
    instance.loginPopup(loginRequest);
  };

  return (
    <div>
      <button
        className={classes.loginButton}
        onClick={handleADLogin}
        color="inherit"
      >
        {t("login.loginADButtonText")}
      </button>
    </div>
  );
};